// src/services/CountryService.js
import api from "./api";

export function getUniversity(page = 1, limit = 10) {
    return api.get(
        `/university?page=${page}&limit=${limit}&list=all`
    );
}
